import { FilterSchedulerItem } from './item';

export class FilterPreference {
  departmentId: number;
  name: string;
  includeTypeOfMaterial: boolean;
  typeOfAssemblyTypes: TypeOfAssemblyTypeOption[];
  machines: { area: 'production' | 'packing'; shortName: string }[];
  lang: 'es' | 'en';
}

export type TypeOfAssemblyTypeOption = {
  id: number;
  title: string;
  items?: FilterSchedulerItem[];
  cardClass: string;
  headerClass: string;
  selected: boolean;
};

export const availableOptions: FilterPreference[] = [
  {
    departmentId: 8,
    name: 'Filter',
    typeOfAssemblyTypes: [
      {
        id: 21,
        title: 'Silicone',
        items: [],
        cardClass: 'tw-bg-[#ddd]',
        headerClass: '',
        selected: true,
      },
      {
        id: 20,
        title: 'Urethane',
        items: [],
        cardClass: 'tw-bg-[#46606A]',
        headerClass: 'tw-text-white',
        selected: true,
      },
    ],
    lang: 'es',
    includeTypeOfMaterial: true,
    machines: [
      { area: 'production', shortName: 'URE' },
      { area: 'production', shortName: 'SIL' },
      { area: 'packing', shortName: 'PAC1' },
      { area: 'packing', shortName: 'PAC2' },
    ],
  },
];
